<template>
  <el-dialog
    title="修改分享商品属性"
    center
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <!--form表单-->
    <el-form size="small" ref="form" :model="toGoodSetting">
      <el-form-item label="Id：" style="display: none">
        <span>{{ toGoodSetting.share_list_id }}</span>
      </el-form-item>
      <el-form-item label="类型：">
        <span>{{ toGoodSetting.goods_type }}</span>
      </el-form-item>
      <el-form-item label="标题：">
        <span>{{ toGoodSetting.goods_title }}</span>
      </el-form-item>

      <el-form-item label="状态">
        <!-- {{toGoodSetting.setting.status}} -->
        <el-radio-group v-model="toGoodSetting.setting.status">
          <el-radio label="1">正常</el-radio>
          <el-radio label="0">待审</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="收益模式">
        <el-radio-group v-model="toGoodSetting.setting.reward_model">
          <el-radio label="1">一级分享</el-radio>
          <el-radio label="2">二级分享</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="分享推荐">
        <el-radio-group v-model="toGoodSetting.setting.is_share">
          <el-radio label="1">是</el-radio>
          <el-radio label="0">否</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="奖励类型">
        <el-radio-group v-model="toGoodSetting.setting.reward_type">
          <el-radio label="1">红包</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="奖励总数" :inline="true">
        <div>
          <el-input
            style="width: 340px"
            v-model="toGoodSetting.setting.reward_total"
            placeholder="奖励总数"
          ></el-input>
        </div>
      </el-form-item>

      <el-form-item label="一级分享范围">
        <div class="rewardArea">
          <el-input
            style="width: 150px"
            v-model="toGoodSetting.setting.reward_min_first"
            placeholder="奖励最小值"
          ></el-input>
          <span>至</span>
          <el-input
            style="width: 150px"
            v-model="toGoodSetting.setting.reward_max_first"
            placeholder="奖励最大值"
          ></el-input>
        </div>
      </el-form-item>
      <el-form-item label="二级分享范围">
        <div class="rewardArea">
          <el-input
            style="width: 150px"
            v-model="toGoodSetting.setting.reward_min_second"
            placeholder="奖励最小值"
          ></el-input>
          <span>至</span>
          <el-input
            style="width: 150px"
            v-model="toGoodSetting.setting.reward_max_second"
            placeholder="奖励最大值"
          ></el-input>
        </div>
      </el-form-item>

      <el-form-item label="有效时间">
        <el-date-picker
          v-model="toGoodSetting.setting.effective_time"
          type="daterange"
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="onEdit" :loading="loading"
        >确 定</el-button
      >
    </div>
  </el-dialog>
</template>
<script>
import ShareApi from "@/api/sharepolite.js";

export default {
  data() {
    return {
      editShareEffectiveTime: "",
      dialogVisible: true,
      loading: false,
      ruleForm: {
        date1: "",
        date2: "",
      },
      form: {
        status: 0,
      },
    };
  },
  props: ["toGoodSetting", "editShareStatus"],
  methods: {
    /*关闭弹窗*/
    dialogFormVisible(e) {
      if (e) {
        this.$emit("close", {
          type: "success",
          openDialog: false,
        });
      } else {
        this.$emit("close", {
          type: "error",
          openDialog: false,
        });
      }
    },
    /*修改*/
    onEdit() {
      let params = {
        setting: this.toGoodSetting.setting,
        list_id: this.toGoodSetting.share_list_id,
      };
      ShareApi.editShareGoods(params, true)
        .then((data) => {
          this.$message({
            message: "分享商品修改成功",
            type: "success",
          });
          this.dialogFormVisible(true);
        })
        .catch((error) => {
          this.loading = false;
        });
    },
  },
  created() {
    this.form.status = this.toGoodSetting.setting.status;
  },
};
</script>

<style lang="scss" scoped>
.ref {
  display: flex;
  flex-direction: column;
}
el-form > div {
  margin: 10px 0;
}
.rewardArea {
  display: flex;
}
.rewardArea .el-input {
  width: 140px;
  margin: 0 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/sharepolite/editGoods/editGoods.vue